import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  font-size: ", "px;\n  margin-bottom: ", ";\n  position: relative;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { rem } from '@scp/ui-shared/theme/utils';
import { FIELD_FONT_SIZE, FIELD_MARGIN_BOTTOM, FIELD_MARGIN_BOTTOM_SMALL } from './constants';
import { FieldSubtext } from './FieldSubtext';

function getMargin(_ref) {
  var hideError = _ref.hideError,
      hint = _ref.hint,
      smallMarginBottom = _ref.smallMarginBottom;
  if (smallMarginBottom) return rem(FIELD_MARGIN_BOTTOM_SMALL);
  return !hideError || hint ? rem(FIELD_MARGIN_BOTTOM) : 0;
}

var Wrapper = styled.div(_templateObject(), FIELD_FONT_SIZE, function (props) {
  return getMargin(props);
});
/**
 * @example ./__docs__/FieldWrapper.md
 */

export var FieldWrapper = function FieldWrapper(_ref2) {
  var id = _ref2.id,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? null : _ref2$children,
      _ref2$hideError = _ref2.hideError,
      hideError = _ref2$hideError === void 0 ? false : _ref2$hideError,
      _ref2$smallMarginBott = _ref2.smallMarginBottom,
      smallMarginBottom = _ref2$smallMarginBott === void 0 ? false : _ref2$smallMarginBott,
      _ref2$errorText = _ref2.errorText,
      errorText = _ref2$errorText === void 0 ? '' : _ref2$errorText,
      role = _ref2.role,
      hint = _ref2.hint;
  return React.createElement(Wrapper, {
    hideError: hideError,
    hint: hint,
    smallMarginBottom: smallMarginBottom,
    role: role
  }, children, !hideError && React.createElement(FieldSubtext, {
    type: "error",
    id: "".concat(id, "-error")
  }, errorText), hint && (hideError || !errorText) && React.createElement(FieldSubtext, {
    type: "hint"
  }, hint));
};